// extracted by css-extract-rspack-plugin
export default {"Accordion":"Accordion-module__Accordion__Wt35q"};